import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const registerSchema = Yup.object().shape({
  first_name: Yup.string().required(REQUIRED_ERROR_MSG),
  last_name: Yup.string().required(REQUIRED_ERROR_MSG),
  email: Yup.string()
    .email()
    .matches(
      /.+(@hybridmmafit.com|@sidebench.com|@blink22.com)/,
      'You must have “@hybridmmafit.com“ email'
    )
    .required(REQUIRED_ERROR_MSG),
  password: Yup.string()
    .required(REQUIRED_ERROR_MSG)
    .min(6, 'Password is too short - should be 6 chars minimum.'),
  gym_id: Yup.string().required(REQUIRED_ERROR_MSG)
});
